// extracted by mini-css-extract-plugin
export default {"wrapper":"PvPerformanceConfig_wrapper__I0tkL","warningColor":"PvPerformanceConfig_warningColor__bAS9q"};